export default (action) => {
  return new Promise((resolve) => {
    window.grecaptcha.ready(() => {
      return resolve(window.grecaptcha.execute({ action }));
    });
  });
};
